import { Toolbar, Divider, Box } from "@mui/material";
import EstateSelect from "./EstateSelect";

import RefreshButton from "../App/RefreshButton";

function EstateSelectToolbar({ noTicketFilter = true }) {
  return (
    <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
      <Box sx={{ flexGrow: 1 }}>
        <EstateSelect />
      </Box>

      {noTicketFilter && (
        <>
          <Divider orientation="vertical" flexItem />
          <RefreshButton />
        </>
      )}
    </Toolbar>
  );
}

export default EstateSelectToolbar;
